import React, { useEffect, useState } from "react";
import { Row, Col, Card, ListGroup } from "react-bootstrap";
import { FiShoppingBag, FiCalendar, FiTruck } from "react-icons/fi";

const InfoOrdiniDettagliato = () => {
  const [data, setData] = useState({ oggi: 0, listaOggi: [], settimana: 0, listaSettimana: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("./ordini_urgenti.json")
      .then((res) => res.json())
      .then((json) => {
        const ordini = json?.ORDINI_URGENTI?.flat() || [];
        
        // --- DATE DINAMICHE ---
        const adesso = new Date();
        // Formato YYYY-MM-DD per il confronto stringa
        const oggiStr = adesso.toISOString().split('T')[0]; 
        
        // Calcolo 7 giorni fa
        const unaSettimanaFa = new Date();
        unaSettimanaFa.setDate(adesso.getDate() - 7);
        unaSettimanaFa.setHours(0, 0, 0, 0); // Reset orario per confronto corretto

        const mapOggi = {};
        const mapSettimana = {};
        let totaleOggi = 0;
        let totaleSettimana = 0;

        ordini.forEach(item => {
          if (item["Tipo Riga"] === "T") {
            const importo = parseFloat(item["Importo"]) || 0;
            const fornitore = item["Ragione sociale"] || "Sconosciuto";
            const dataDocStr = item["Data Ordine"]?.split(" ")[0]; // Prende YYYY-MM-DD
            const dataDoc = new Date(dataDocStr);

            // Logica OGGI dinamica
            if (dataDocStr === oggiStr) {
              totaleOggi += importo;
              mapOggi[fornitore] = (mapOggi[fornitore] || 0) + importo;
            }

            // Logica SETTIMANA dinamica (ultimi 7 giorni fino a ora)
            if (dataDoc >= unaSettimanaFa && dataDoc <= adesso) {
              totaleSettimana += importo;
              mapSettimana[fornitore] = (mapSettimana[fornitore] || 0) + importo;
            }
          }
        });

        const formatLista = (obj) => 
          Object.entries(obj)
            .map(([nome, valore]) => ({ nome, valore }))
            .sort((a, b) => b.valore - a.valore);

        setData({
          oggi: totaleOggi,
          listaOggi: formatLista(mapOggi),
          settimana: totaleSettimana,
          listaSettimana: formatLista(mapSettimana)
        });
        setLoading(false);
      })
      .catch(err => {
        console.error("Errore statistiche:", err);
        setLoading(false);
      });
  }, []);

  const formatEuro = (v) => new Intl.NumberFormat('it-IT', { 
    style: 'currency', 
    currency: 'EUR', 
    maximumFractionDigits: 0 
  }).format(v);

  const RenderLista = ({ lista }) => (
    <div className="hide-scrollbar" style={{ maxHeight: "180px", overflowY: "auto", marginTop: "10px" }}>
      <ListGroup variant="flush">
        {lista.length > 0 ? lista.map((f, i) => (
          <ListGroup.Item key={i} className="d-flex justify-content-between align-items-center p-2 border-0 bg-transparent" style={{ fontSize: "0.75rem" }}>
            <span className="text-truncate text-light me-2" style={{ maxWidth: "60%" }}>{f.nome}</span>
            <span className="fw-bold text-light text-nowrap">{formatEuro(f.valore)}</span>
          </ListGroup.Item>
        )) : <div className="text-muted p-2 small">Nessun dato</div>}
      </ListGroup>
    </div>
  );

  return (
    <Card className="bg-dark text-light shadow-lg" style={{ borderRadius: "10px", border: "1px solid #444", overflow: "hidden" }}>
      
      <style>{`
        .hide-scrollbar::-webkit-scrollbar { display: none !important; }
        .hide-scrollbar { scrollbar-width: none !important; -ms-overflow-style: none !important; }
        .divider-vertical { border-right: 1px solid #444; }
        .text-title { text-transform: uppercase; font-weight: bold; letter-spacing: 1px; color: #aaa; font-size: 0.85rem; }
      `}</style>

      <div className="mt-2 text-center border-bottom border-secondary pb-2">
        <span className="text-title">ORDINI RICEVUTI - ITALIA</span>
      </div>

      <Card.Body className="p-0">
        <Row className="g-0">
          <Col xs={6} className="p-4 divider-vertical">
            <div className="d-flex align-items-center mb-3">
              <div className="bg-light text-dark p-2 rounded-circle me-3 shadow-sm d-flex align-items-center justify-content-center" style={{width: "35px", height: "35px"}}>
                <FiShoppingBag size={18} />
              </div>
              <div>
                <div className="text-uppercase text-muted fw-bold" style={{ fontSize: "0.6rem" }}>Oggi</div>
                <h4 className="mb-0 fw-bold text-white">{loading ? "..." : formatEuro(data.oggi)}</h4>
              </div>
            </div>
            <div className="text-light mb-2 fw-bold opacity-75" style={{ fontSize: "0.7rem" }}>
              <FiTruck className="me-1"/> TOP FORNITORI:
            </div>
            <RenderLista lista={data.listaOggi} />
          </Col>

          <Col xs={6} className="p-4">
            <div className="d-flex align-items-center mb-3">
              <div className="bg-light text-dark p-2 rounded-circle me-3 shadow-sm d-flex align-items-center justify-content-center" style={{width: "35px", height: "35px"}}>
                <FiCalendar size={18} />
              </div>
              <div>
                <div className="text-uppercase text-muted fw-bold" style={{ fontSize: "0.6rem" }}>Settimana</div>
                <h4 className="mb-0 fw-bold text-light">{loading ? "..." : formatEuro(data.settimana)}</h4>
              </div>
            </div>
            <div className="text-light mb-2 fw-bold opacity-75" style={{ fontSize: "0.7rem" }}>
              <FiTruck className="me-1"/> TOP FORNITORI:
            </div>
            <RenderLista lista={data.listaSettimana} />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default InfoOrdiniDettagliato;